import { apiClient } from './apiClient';

export interface EuaBalanceHistoryEntry {
  id: string;
  entityId: string;
  previousBalance: number;
  newBalance: number;
  changeAmount: number;
  changeType: 'ADMIN_ADJUSTMENT' | 'PROCUREMENT' | 'ALLOCATION' | 'TRANSFER' | 'CORRECTION';
  reason: string;
  updatedBy: string;
  updatedByName: string;
  timestamp: string;
  metadata?: Record<string, unknown>;
}

export async function getEntityBalanceHistory(
  entityId: string,
  limit: number = 50
): Promise<EuaBalanceHistoryEntry[]> {
  const result = await apiClient.get<EuaBalanceHistoryEntry[] | null>(
    `/entities/${entityId}/balance-history?limit=${limit}`
  );
  // Handle null response from Firestore when no history exists
  return result || [];
}
